module.exports = __webpack_public_path__ + "2f6eab849edeac3a1f92a8a8d3a78f81.jpg";